export default function (data) {
  var self = this;
  self.all_resourcings = ko.observableArray([]);

  self.bindData = function(data) {
    self.all_resourcings(data);
  };

  const __construct = function(that) {
    console.log('constructor called for CommonResourceShowViewModel');
    that.bindData(data);
  }(this);
}
